import React from 'react';

import { useTranslation } from 'Shared/Hooks/useTranslation';

import PlayOutline from 'crehana-icons/PlayOutline';
import Document from 'crehana-icons/Document';
import Clock3 from 'crehana-icons/Clock3';
import LargeBadge from 'crehana-icons/LargeBadge';
import { baseLighter } from 'crehana-ui/styles/colors';
import locales from '../../i18n/localeEs';
import { toMinutes } from 'Jsx/Utils/date';

const translations = locales.es;

const InfoSection: React.FC<{
  totalLessons: number;
  totalAttachments: number;
  totalDuration: number;
  iconColor?: string;
  className?: string;
  iSStickyCard?: boolean;
}> = ({
  totalLessons,
  totalAttachments,
  totalDuration,
  iconColor = baseLighter,
  className,
  iSStickyCard,
}) => {
  const { t } = useTranslation();

  return (
    <section
      className={`${
        iSStickyCard ? 'hidden md:block mt-16' : 'md:hidden mb-16'
      } ${className || ''}`}
    >
      <h2 className="font-h4 mb-16 font-bold">
        {t('INFO_SECTION_TITLE', {
          defaultValue: translations.INFO_SECTION_TITLE,
        })}
      </h2>
      <ul>
        {totalDuration > 0 && (
          <li className="mb-12 flex items-center">
            <div className="h-16 w-16 text-center">
              <Clock3 size={14} color={iconColor} />
            </div>
            <p className="font-body2 ml-8">
              {t('TOTAL_DURATION', {
                defaultValue: translations.TOTAL_DURATION,
              })}{' '}
              {toMinutes(totalDuration)}
            </p>
          </li>
        )}

        {totalLessons > 0 && (
          <li className="mb-12 flex items-center">
            <div className="h-16 w-16 text-center">
              <PlayOutline size={16} color={iconColor} />
            </div>
            <p className="font-body2 ml-8">
              {totalLessons}{' '}
              {t('TOTAL_LESSONS_TEXT', {
                defaultValue: translations.TOTAL_LESSONS_TEXT,
              })}
            </p>
          </li>
        )}

        {totalAttachments > 0 && (
          <li className="mb-12 flex items-center">
            <div className="h-16 w-16 text-center">
              <Document size={11} color={iconColor} />
            </div>
            <p className="font-body2 ml-8">
              {totalAttachments}{' '}
              {t('TOTAL_ATTACHMENTS_TEXT', {
                defaultValue: translations.TOTAL_ATTACHMENTS_TEXT,
              })}
            </p>
          </li>
        )}

        <li className="mb-12 flex items-center">
          <div className="h-16 w-16 text-center">
            <LargeBadge size={16} color={iconColor} />
          </div>
          <p className="font-body2 ml-8">
            {t('CERTIFIES_TEXT', {
              defaultValue: translations.CERTIFIES_TEXT,
            })}
          </p>
        </li>
      </ul>
    </section>
  );
};

export default InfoSection;
